import { render, staticRenderFns } from "./progres_init.vue?vue&type=template&id=a374f9f0&scoped=true"
import script from "./progres_init.vue?vue&type=script&lang=js"
export * from "./progres_init.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a374f9f0",
  null
  
)

export default component.exports